import { DSDrawer, styled } from '@vr/ds-react'

export const Drawer = styled(DSDrawer, {
  height: '30vh !important'
})

export const Content = styled('div', {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: `calc(80% - ${'$md32'} * 2)`,
  margin: '0 auto',
  marginTop: '$md32'
})
